export default __webpack_public_path__ + "e42ad136e648f0a8aa8b67a63b28bd6e.png";